import React from "react";
import {Button, Space, Typography} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Translate} from "../../../hooks/translate.hook";
import {HealthCheckerIncident} from "../../../models/health-checker/health-checker";
import {formatHealthCenterDateTime} from "../health-center.helpers";
import {SmartColumn} from "../../common/smart-table/smart-table.model";
import {FieldType} from "../../common/smart-table/smart-table.field-config";

const {Paragraph, Text} = Typography;

export const incidentsColumnsFactory = (
    t: Translate,
    onDownload: (incident: HealthCheckerIncident) => Promise<void>,
    downloadingId?: number
): SmartColumn<HealthCheckerIncident>[] => {
    return [
        {
            name: "id",
            visibleName: t("HEALTH-CENTER.ISSUE.INCIDENTS.ID", {defaultValue: "Incident"}),
            type: FieldType.INTEGER,
            render: (id: number) => <Text strong>#{id}</Text>,
        },
        {
            name: "createdAt",
            visibleName: t("HEALTH-CENTER.ISSUE.INCIDENTS.OCCURRED-AT", {defaultValue: "Occurred at"}),
            type: FieldType.DATETIME,
            filterable: true,
            render: (createdAt: string, incident) => (
                <Space direction="vertical" size={0}>
                    <Text className="health-center-issue__incident-date">
                        {formatHealthCenterDateTime(createdAt)}
                    </Text>
                </Space>
            ),
        },
        {
            name: "description",
            visibleName: t("HEALTH-CENTER.ISSUE.INCIDENTS.DESCRIPTION", {defaultValue: "Description"}),
            type: FieldType.STRING,
            filterable: true,
            render: (description: string) => (
                <Paragraph className="health-center-issue__incident-description">
                    {description}
                </Paragraph>
            ),
        },
        {
            name: "data",
            visibleName: t("HEALTH-CENTER.ISSUE.INCIDENTS.DATA", {defaultValue: "Additional data"}),
            type: FieldType.BOOLEAN,
            render: (hasData: boolean, incident) => hasData ? (
                <Button
                    size="small"
                    icon={<FontAwesomeIcon icon={["fas", "download"]} />}
                    loading={downloadingId === incident.id}
                    disabled={downloadingId !== undefined && downloadingId !== incident.id}
                    onClick={() => void onDownload(incident)}
                >
                    {t("HEALTH-CENTER.ISSUE.INCIDENTS.DOWNLOAD", {defaultValue: "Download data"})}
                </Button>
            ) : <Text type="secondary">—</Text>,
        },
    ];
};
